import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import RelationDataTable from '../datatable/RelationDataTable';
import Thumbnail from '../thumbnail/Thumbnail';
import { COLUMN_STYLE, getColumnStyle } from '../datatable/util';
import Constants from '../../config/constants';
import {
  addLightingSetBallast,
  editLightingSetBallast,
  removeLightingSetBallast,
  addTobeCreatedBallast,
  editTobeCreatedBallast,
  removeTobeCreatedBallast
} from '../../redux/luminaire/lightingset_actions';
import { searchBallastByText } from '../../redux/luminaire/ballast_actions';
import {defaultRejectHandler} from "../../utils/utility";

export class BallastDataTable extends React.Component {
  constructor(props) {
    super(props);
    const { t } = props;

    this.search = {
      pageSize: Constants.DEFAULT_PAGE_SIZE,
      page: null,
      sorted: null,
      filtered: null,
    };

    const textColumn = getColumnStyle(COLUMN_STYLE.text);
    const coeColumn = getColumnStyle(COLUMN_STYLE.coefficient);
    const decimalColumn = getColumnStyle(COLUMN_STYLE.decimal);

    this.columns = [
      {
        Header: '',
        accessor: 'ballast.thumbnail',
        Cell: row => <Thumbnail img={row.value} />,
        ...getColumnStyle(COLUMN_STYLE.thumbnail),
      },
      {
        Header: () => <b>{t('name')}</b>,
        accessor: 'ballast.name',
        ...textColumn,
        entity: {
          list: (text, page) => searchBallastByText(text, page)
            .then(response => response.data.map((balast) => ({label: balast.name, value: String(balast.id), original: balast}))),
          create: null,
        },
      },
      {
        Header: () => <b>{t('quantity')}</b>,
        accessor: 'quantity',
        ...decimalColumn,
        width: 80,
        attr: {
          type: 'number',
          isRequired: true,
          props: { min: 1 },
        },
      },
      {
        Header: () => <b>{t('power (W)')}</b>,
        accessor: 'ballast.power_required',
        ...coeColumn,
        width: 120,
      },
    ];

    this.state = {
      categoryOption: 'all',
      selectedItem: null,
    };
  }

  updateSortFilter(filter, state, category) {
    if (state) {
      this.search.pageSize = state.pageSize;
      this.search.page = state.page;
      this.search.sorted = state.sorted;
    }
    this.search.filtered = filter;

    this.setState({ categoryOption: category });
  }

  editItem(item) {
    this.setState({
        isShowEditModal: true,
        selectedItem: item.original,
      },
      () => {
        if (this.props.onEditItem) {
          this.props.onEditItem(this.state.selectedItem);
        }
      },
    );
  }

  render() {
    const {
      categoryOption,
      selectedItem: item,
    } = this.state;

    const {
      lightingSetId,
      filtered,
      filteredCount,
      isLoading,
      addBallast,
      removeBallast,
      editBallast,
      isBallastAdding,
      isBallastEditing,
      isBallastRemoving,
      addTobeCreatedBallast,
      editTobeCreatedBallast,
      removeTobeCreatedBallast,
      mode,
      t,
    } = this.props;

    const relationship = {
      create: (({ name, entityId, quantity, original }) => {
        if (mode === 'edit') { 
          addBallast(lightingSetId, entityId, quantity);
        } else{
          addTobeCreatedBallast(quantity, original, this.props.ballasts) 
        }
      }).bind(this),
      delete: (id, rel) => {
        if (mode === 'edit') { 
          removeBallast(id, lightingSetId);
        } else{
          removeTobeCreatedBallast(rel.ballast.id);
        }        
      },
      edit: ({ id, quantity, ballast }) => {
        if (mode === 'edit') { 
          editBallast(id, quantity)
        } else{
          editTobeCreatedBallast(ballast.id, quantity) 
        }
      },
      isCreating: isBallastAdding,
      isEditing: isBallastEditing,
      isDeleting: isBallastRemoving,
    };

    return (
      <div>
        <div style={{ backgroundColor: 'white' }}>
          <RelationDataTable
            columns={this.columns}
            data={this.props.ballasts}
            relationship={relationship}
            relationshipNameAccessor={item => item.ballast.name}
            classNamePrefix="select-lightingset-ballast"
            onActionEdit={item => this.editItem(item)}
            onActionDelete={item => this.setState({ isShowDeleteModal: true, selectedItem: item.original })}
            filteredCount={filteredCount}
            isLoading={isLoading}
            onFetchData={state => this.updateSortFilter(filtered, state, categoryOption)}
          />
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  isBallastAdding: state.lighting.lightingset.isBallastAdding,
  isBallastEditing: state.lighting.lightingset.isBallastEditing,
  isBallastRemoving: state.lighting.lightingset.isBallastRemoving,
});

const mapDispatchToProps = dispatch => ({
  addBallast: (lightingSetId, ballastId, quantity) => defaultRejectHandler(dispatch(addLightingSetBallast(lightingSetId, ballastId, quantity))),
  addTobeCreatedBallast: (quantity, ballast, tobeCreatedballastarry) => defaultRejectHandler(dispatch(addTobeCreatedBallast(quantity, ballast, tobeCreatedballastarry))),
  removeBallast: (lightingSetBallastId, lightingSetId) => defaultRejectHandler(dispatch(removeLightingSetBallast(lightingSetBallastId, lightingSetId))),
  removeTobeCreatedBallast: (ballastId) => defaultRejectHandler(dispatch(removeTobeCreatedBallast(ballastId))),
  editBallast: (lightingSetBallastId, quantity) => defaultRejectHandler(dispatch(editLightingSetBallast(lightingSetBallastId, quantity))),
  editTobeCreatedBallast: (ballastId, quantity)=> defaultRejectHandler(dispatch(editTobeCreatedBallast(ballastId, quantity))),
});

export default translate('translations', { withRef: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
  )(BallastDataTable),
);



// WEBPACK FOOTER //
// ./src/components/light/BallastDataTable.js